export default "__VITE_ASSET__k1kTV0k4__"